// ** Icons Import
import {
    FileText,
    Circle,
    Navigation2,
    DollarSign,
    Users,
    Book
  } from 'react-feather'
  
  export default [
    {
      header: 'Extensiones',
      action: 'level-0',
      resource: 'customer'
    },
    {
      id: 'dashboard',
      title: 'Gestión de niños',
      icon: <Users size={20} />,
      action: 'level-0',
      resource: 'customer',
      navLink: '/customer/dashboard'
    },

    {
      header: 'Bancamiga Wallet',
      action: 'level-0',
      resource: 'customer'
    },
    {
      id: 'test',
      title: 'Historial',
      icon: <Book size={20} />,
      action: 'level-0',
      resource: 'customer',
      navLink: '/customer/record'
    },
    {
      id: 'wallet',
      title: 'Wallet',
      icon: <DollarSign size={20} />,
      action: 'level-0',
      resource: 'customer',
      navLink: '/customer/wallet'
    }
  ]
  